import React from "react";

import { Template } from "@/types/template";

import { TemplateCardActive } from "./TemplateCardActive";
import { TemplateCardComingSoon } from "./TemplateCardComingSoon";

interface TemplateCardProps {
  template: Template;
  onSelect: (template: Template) => void;
}

export const TemplateCard = React.memo<TemplateCardProps>(
  ({ template, onSelect }) => {
    if (!template.isActive) {
      return <TemplateCardComingSoon template={template} />;
    }
    return <TemplateCardActive template={template} onSelect={onSelect} />;
  }
);
